const ASSET_CLASSES = {
  pandhoraEssencial: {
    name: "Pandhora Essencial",
    dbName: "Pandhora Essencial FIC FIM",
    color: "#FFB800",
    colorName: "yellow",
    fundId: 2,
  },
  pandhoraLb: {
    name: "Pandhora Long Bias",
    dbName: "Pandhora Long Bias FIC FIM",
    color: "#0D226A",
    colorName: "dark-blue",
    fundId: 4,
  },
  rendaFixa: {
    name: "Renda Fixa Pós-fixada",
    altName: "CDI",
    dbName: "CDI",
    colorName: "light-yellow",
    color: "#FFE36E",
    indexId: 1,
  },
  ipca: {
    name: "Cesta Tesouro IPCA+",
    altName: "IMA-B",
    dbName: "IPCA",
    colorName: "light-yellow2",
    color: "#F9EAAD",
    indexId: 4,
  },
  multimercado: {
    name: "Multimercado",
    altName: "IHFA",
    dbName: "IHFA",
    colorName: "light-yellow3",
    color: "#F9F9C7",
    indexId: 3,
  },
  rendaVariavel: {
    name: "Renda Variável",
    altName: "IBOVESPA",
    dbName: "Ibovespa",
    colorName: "grey",
    color: "#C4C4C4",
    indexId: 2,
  },
  rendaVariavelGlobal: {
    name: "Renda Variável Global",
    altName: "IVVB",
    dbName: "SPX BRL",
    colorName: "dark-grey",
    color: "#616161",
    indexId: 5,
  },
  dolar: {
    name: "Dólar",
    altName: "USDBRL",
    dbName: "USDBRL",
    colorName: "black",
    color: "#262626",
    indexId: 6,
  },
};

export default ASSET_CLASSES;
